export interface BoundingBox {
  ne: GeoCoordinates;
  sw: GeoCoordinates;
}

export interface GeoCoordinates {
  lat: number;
  lon: number;
}

export interface CrossBoundingBox {
  pointMaxLat: GeoCoordinates;
  pointMaxLon: GeoCoordinates;
  pointMinLat: GeoCoordinates;
  pointMinLon: GeoCoordinates;
}
